import React, { useState, useEffect, useRef } from "react";
import "./Software.scss";
import axios from "axios";
import moment from 'moment';
import leftArrow from '../../images/Left-arrow.svg';
import rightArrow from '../../images/right-arrow.png';
import Switch from "@mui/material/Switch";
import basicImage from "../../images/basic.svg";  
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import SoftwareImage from "../../components/Image/softwareImage"
import CompanyImageComponent from "../../components/Image/CompanyLogoSoftware"
import defaultLogo from '../../images/default_logo.jpg';
import {useNavigate } from 'react-router-dom';

function Packs() {
  const [bundlesData, setBundlesData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);
  const [selectedUploadId, setSelectedUploadId] = useState(null);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [checked, setChecked] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [numLogosDisplayed, setNumLogosDisplayed] = useState(4);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [companyLogos, setCompanyLogos] = useState([]);

    useEffect(() => {
    axios
      .get("/v1/masterpack/listAllPacks",{
        headers: {
          'Authorization': 'Bearer'+' '+sessionStorage.getItem("access_token"),
        }})
      .then(response => {
        setBundlesData(response.data.data);
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, []);



  // const handleNext = () => {
  //   setCurrentIndex(prevIndex => prevIndex + 1);
  // };

  // const handlePrev = () => {
  //   setCurrentIndex(prevIndex => prevIndex - 1);
  // };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return moment(date).format('DD-MMM-YYYY'); 
  };
  
  const handleButtonClick = (te_prepid) => {
    setSelectedUploadId(te_prepid);
    const bundle = bundlesData.find(bundle => bundle.te_prepid === te_prepid);
    setSelectedBundle(bundle);


    axios
    .get(`/v1/masterpack/list/${te_prepid}`, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
      }
    })
    .then(response => {
      const bundleDetails = response.data.data[0];
      setSelectedBundle(bundleDetails);
    })
    .catch(error => {
      console.error("Error fetching bundle details:", error);
    });

    axios
    .get(`/v1/licensedetails/CompanyInfo/${te_prepid}`, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
      }
    })
    .then(response => {
     
      // console.log("companyInfo",response.data)
      // setCompanies(response.data);
      // const logos = response.data.data.map(item => item.master_company.te_companylogosmall);
      //   setCompanyLogos(logos);
      if (response.data.message === "Invalid request! companyid does not exist for license ") {
        setErrorMessage("No companys found for this software");
        setCompanyLogos([]);
      } else {
        const logos = response.data.data.map(item => item.master_company.te_companylogosmall);
        setCompanies(response.data);
        setCompanyLogos(logos);
        setErrorMessage(null);
      }
    })
    .catch(error => {
      console.error("Error fetching company info:", error);
    });
};


useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth >= 1080) {
      console.log(">1080")
      setNumLogosDisplayed(4);
    }
  
    else if (window.innerWidth < 1080 && window.innerWidth >= 840) {
      console.log("1080")
      setNumLogosDisplayed(3);
    }
    else if (window.innerWidth < 840) {
      console.log("840")
      setNumLogosDisplayed(2);
    }

    ;
  };
  window.addEventListener('resize', handleResize);
  return () => {
    window.removeEventListener(
      'resize'
      , handleResize);
  };
});
const handleNext = () => {
  setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, companyLogos.length - numLogosDisplayed));
};

const handlePrev = () => {
  setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
};

const navigate = useNavigate();

const handleCompanyClick = (te_lmsid) => {
  navigate('/LiceseDetails/' + te_lmsid);
};
  return (
    <div className=" Software-details">
      <div className="d-flex ">
        <h5 style={{ marginRight: "auto", fontSize: "35px",marginBottom:"30px"  }}>Software Details</h5>
      </div>
      <div className="container-main m-0" >
        <div className="grid-1 relative-position">
          <div className="heading">Active Bundles’s</div>
      
          <div className="bundle-display">
          {/* <button className="nav-btn prev" onClick={handlePrev} disabled={currentIndex === 0}>
              <img src={leftArrow} className="shift-arrow" alt="Previous" />
            </button> */}

                     {bundlesData.length === 0 ? (
                      <div className="col text-center">
                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center",margin:"100px"}}>
                          <CircularProgress color="inherit"/>
                        </Box>
                      </div>
                    ) : (
          <div className="bundle-details" ref={containerRef} style={{ display: "flex" }}>
            {bundlesData.map((bundle) => (
              <div className="card-button">
              <div className="img-container">
                {/* <img className="img-size" src={basicImage}/> */}
                <SoftwareImage className="img-size" style={{ width: "9px", height: 'auto'}} image={bundle.te_softwarelogo} />
              </div>
              <div key={bundle.te_prepid} className="card" >
                <p className="m-0">Bundle Size</p>
                <p style={{marginBottom:"0.5rem"}}> {bundle.te_inputfilesizeingb} GB</p>
                <p className="m-0">Release date</p>
                <p style={{marginBottom:"0.5rem"}}>{formatDate(bundle.te_iscreatedat)}</p>
                <p className="m-0">Version</p>
                <p style={{marginBottom:"0.5rem"}}>{bundle.masterpack_bundles.te_version}</p>
                {/* <p>1.2.2</p> */}
              </div>
              <div className="button-container">
              <button className="know-more-botton" onClick={() => handleButtonClick(bundle.te_prepid)}
                      style={{
                        backgroundColor: selectedUploadId === bundle.te_prepid ? '#334456' : '#F9F8F4',
                        color: selectedUploadId === bundle.te_prepid ? '#F9F8F4' : '#3C4147',
                        boxShadow:selectedUploadId === bundle.te_prepid ?'none' : '2px 2px 0px #334456',
                      }}
              >Know more</button></div>
              </div>
            ))}
          </div>
)}
            {/* <button className="nav-btn next" onClick={handleNext} disabled={currentIndex + 5 >= bundlesData.length}>
              <img src={rightArrow} className="shift-arrow" alt="Next" />
            </button> */}
            </div>
        
        </div>
        {selectedBundle && selectedBundle.te_prepid === selectedUploadId && (
        <div className="bottom-container">
 
          <div className="grid-2 ">
            <div className="heading">Companies Using Basic Bundle</div>
            {errorMessage ? (
                <div className="error-message">{errorMessage}</div>
              ) : (
            <div className="company-logos-container">

                  <button className="nav-btn prev" onClick={handlePrev} disabled={currentIndex === 0}>
                    <img src={leftArrow} className="shift-arrow" alt="Previous" />
                  </button>
                  {companyLogos.length === 0 ? (
                    <div className="col text-center">
                      <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", marginTop: "100px" }}>
                        <CircularProgress color="inherit" />
                      </Box>
                    </div>
                  ) : (
                    <div className="company-logos-wrapper">
                      {companyLogos.slice(currentIndex, currentIndex + numLogosDisplayed).map((logo, index) => (
                        <div key={index} className="company-logo">
                          <div className={`rounded-box ${selectedCompany && selectedCompany.te_companyid === logo ? 'selected' : ''}`}
                           onClick={() => handleCompanyClick(companies.data[index + currentIndex].te_lmsid)}
                            >
                            {logo? (<>
                              <CompanyImageComponent className="img-size"  image={logo} />
                            
                            </>) : (
                              <div className="default-logo">
                                <img className="image-size" src={defaultLogo} alt="Default Logo" />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <button className="nav-btn next" onClick={handleNext} disabled={currentIndex + numLogosDisplayed >= companyLogos.length}>
                    <img src={rightArrow} className="shift-arrow" alt="Next" />
                  </button>
                </div>
              )}
            
          </div>
          <div className="grid-3">
            <div className="heading">Basic Bundle Details</div>
            
              <div className="Bundle-Details-container">
                <div className="line line-1">
                  <p className="m-0">Size</p>
                  <p className="mt-0" style={{marginBottom:"0.5rem"}}>{selectedBundle.masterpack_bundles[0]?.te_bundlesizeingb} GB</p>
                  <p className="m-0">Version</p>
                  <p className="mt-0" style={{marginBottom:"0.5rem"}}>{selectedBundle.masterpack_bundles[0]?.te_version}</p>
                  <p className="m-0">Release Date</p>
                  <p className="mt-0 m-0" style={{marginBottom:"0.5rem"}}>{formatDate(selectedBundle.te_iscreatedat)}</p>
                </div>
                <div className="line line-2">
                  <p className="m-0">Uploaded By</p>
                  <p  className="mt-0" style={{marginBottom:"0.5rem"}}>{selectedBundle.masterpack_bundles[0]?.te_uploadedby || "N/A"}</p>
                  {/* <div>

                    Activate
                    <Switch
                      checked={selectedBundle && selectedBundle.te_isactive === 1}
                      onChange={() => {
                        const newIsActive = selectedBundle.te_isactive === 1 ? 0 : 1;
                        setSelectedBundle(prevBundle => ({ ...prevBundle, te_isactive: newIsActive }));
                      }}
                      className="switch"
                    />Deactivate
                  </div> */}
                </div>
                <div className="line line-3">
                  <p className="m-0">Release Notes</p>
                  <p  className="mt-0" style={{marginBottom:"0.5rem"}}>{selectedBundle.masterpack_bundles[0]?.te_releasenote || "No release notes available"}</p>
                </div>
              </div>
          
          </div>
       
        </div>
           )}
      </div>
    </div>
  );
}

export default Packs;
